/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Yearlysave1Inputs */

const zh_pricing_yearlysave1 = /** @type {(inputs: Pricing_Yearlysave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`省 20%`)
};

const en_pricing_yearlysave1 = /** @type {(inputs: Pricing_Yearlysave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save 20%`)
};

const es_pricing_yearlysave1 = /** @type {(inputs: Pricing_Yearlysave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra 20%`)
};

/**
* | output |
* | --- |
* | "Save 20%" |
*
* @param {Pricing_Yearlysave1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_yearlysave1 = /** @type {((inputs?: Pricing_Yearlysave1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Yearlysave1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_yearlysave1(inputs)
	if (locale === "en") return en_pricing_yearlysave1(inputs)
	return es_pricing_yearlysave1(inputs)
});
export { pricing_yearlysave1 as "pricing_yearlySave" }